export default {
	setBetDetail: (state, url) => {
		state.betDetailURL = url
	},
	resetBetDetail: (state) => {
		state.betDetailURL = null
	}
}
